import Home from "pages";
import ForgotPassword from "pages/auth/forgotPassword";
import Login from "pages/auth/login";
import Contact from "pages/dashboard/contact";
import Drafts from "pages/dashboard/drafts";
import Evaluations from "pages/dashboard/evaluations";
import DashboardHome from "pages/dashboard/home";
import Questionnaire from "pages/dashboard/questionnaire";
import { routeConstant } from "./routeConstant";
import FlagEvaluations from "pages/dashboard/flag";
import CGPEvaluations from "pages/dashboard/cgpEvaluations";
import RequestEvaluations from "pages/dashboard/request";
import EvaluationDetail from "pages/dashboard/evaluations/[id]";
import ResetPassword from "pages/auth/resetPassword";
import ArchivedEvaluations from "pages/dashboard/archiveEvaluations";
import EditQuestionnaire from "pages/dashboard/editEvaluations/[id]";
import ContinueQuestionnaire from "pages/dashboard/drafts/[id]";
import CGPEvaluationDetail from "pages/dashboard/cgpEvaluations/[id]";
import Settings from "pages/dashboard/settings";
import MulitpleEvaluationsDetails from "pages/dashboard/viewMultipleEvaluations";

const publicRoute: any = [
  {
    path: routeConstant.home.path,
    title: routeConstant.home.title,
    Component: Home,
  },
  {
    path: routeConstant.login.path,
    title: routeConstant.login.title,
    Component: Login,
  },
  {
    path: routeConstant.forgotPassword.path,
    title: routeConstant.forgotPassword.title,
    Component: ForgotPassword,
  },
  {
    path: routeConstant.resetPassword.path,
    title: routeConstant.resetPassword.title,
    Component: ResetPassword,
  },
];

const privateRoute: any = [
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHome,
  },
  {
    path: routeConstant.questionaire.path,
    title: routeConstant.questionaire.title,
    Component: Questionnaire,
  },
  {
    path: routeConstant.evaluationRecord.path,
    title: routeConstant.evaluationRecord.title,
    Component: Evaluations,
  },
  {
    path: routeConstant.archiveEvaluationRecord.path,
    title: routeConstant.archiveEvaluationRecord.title,
    Component: ArchivedEvaluations,
  },
  {
    path: routeConstant.evaluationRecordDetail.path,
    title: routeConstant.evaluationRecordDetail.title,
    Component: EvaluationDetail,
  },
  {
    path: routeConstant.cgpEvaluationRecordDetail.path,
    title: routeConstant.cgpEvaluationRecordDetail.title,
    Component: CGPEvaluationDetail,
  },
  {
    path: routeConstant.draftEvaluation.path,
    title: routeConstant.draftEvaluation.title,
    Component: Drafts,
  },
  {
    path: routeConstant.flagEvaluation.path,
    title: routeConstant.flagEvaluation.title,
    Component: FlagEvaluations,
  },
  {
    path: routeConstant.cgpEvaluation.path,
    title: routeConstant.cgpEvaluation.title,
    Component: CGPEvaluations,
  },
  {
    path: routeConstant.reqEvaluation.path,
    title: routeConstant.reqEvaluation.title,
    Component: RequestEvaluations,
  },
  {
    path: routeConstant.contact.path,
    title: routeConstant.contact.title,
    Component: Contact,
  },
  {
    path: routeConstant.editEvaluationRecord.path,
    title: routeConstant.editEvaluationRecord.title,
    Component: EditQuestionnaire,
  },
  {
    path: routeConstant.continueDraftEvaluation.path,
    title: routeConstant.continueDraftEvaluation.title,
    Component: ContinueQuestionnaire,
  },
  {
    path: routeConstant.settings.path,
    title: routeConstant.settings.title,
    Component: Settings,
  },
  {
    path: routeConstant.multipleEvaluationRecordDetail.path,
    title: routeConstant.multipleEvaluationRecordDetail.title,
    Component: MulitpleEvaluationsDetails,
  },
];

export { privateRoute, publicRoute };
